import CityPageMosquiteras from "../components/CityPageMosquiteras";

export default function Page() {
  return (
    <CityPageMosquiteras
      name="Fuengirola"
      slug="fuengirola"
      cp="29640"
      poblacion={87007}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5409}
      lng={-4.6261}
      zonas={["Los Boliches", "Centro", "Torreblanca del Sol", "Carvajal"]}
      landmarks={["Paseo Marítimo", "Castillo Sohail"]}
      municipiosLimitrofes={["Mijas", "Benalmádena"]}
      festivalLocal="Feria del Rosario (octubre)"
      contextoTipologico="Alta densidad de apartamentos y áticos con ventanales correderos, ideal mosquiteras correderas, comunidad expat europea exigente."
      isCoreZone={true}
    />
  );
}